import React from "react";
import { useState } from "react";
import PopModal from "../../../Constant/Custom/Models/PopModal";
import { serverUrl } from "../../../Constant/Static/config";
import axios from "axios";

const ChangeStatus = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: "", text: "", icon: "" });
  const [onConfirm, setOnConfirm] = useState(() => () => { });
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [onCancel, setOnCancel] = useState(() => () => { });
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const [data, setData] = useState({ appno: "", status: "P" });
  const [showStatus, setShowStatus] = useState(false);
  const [details, setDetails] = useState();

  const handleChange = (e) => {
    // // console.log("appno",e.value);
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const resetData = () => {
    setData({ appno: "", status: "P" });
    setShowStatus(false);
  };

  const check = async () => {
    // // console.log("appno",appno);

    try {
      if (!data.appno) {
        setModalType({
          title: "Invalid",
          icon: "error",
          text: "Enter the application number",
        });
        setShowCancelButton(false);
        // setOnCancel(() => closeModal);
        setOnConfirm(() => closeModal);
        openModal();
        return;
      }
      const response = await axios.post(
        `${serverUrl}/api/admin/cv/checkStatus`,
        [data.appno]
      );

      if (response.status === 200) {
        setDetails(response.data.result);
        // console.log(response.data.result);

        setShowStatus(true);
      }
    } catch (err) {
      setModalType({
        title: "Invalid",
        icon: "error",
        text: err.response.data.message,
      });
      setShowCancelButton(false);
      setOnConfirm(() => closeModal);
      openModal();
      // console.log("error", err);
    }
  };

  const updateStatusConfirmation = () => {
    if (!data.status || !data.appno) {
      setModalType({
        title: "Invalid",
        icon: "error",
        text: "Fill All the neccessary fields",
      });
      setShowCancelButton(false);
      // setOnCancel(() => closeModal);
      setOnConfirm(() => closeModal);
      openModal();
      return;
    }
    const message = `Do you want to update the status to ` + data.status;
    // console.log(message);

    setModalType({
      title: "Confirmation",
      icon: "info",
      text: message,
    });
    setShowCancelButton(true);
    setOnCancel(() => closeModal);
    setOnConfirm(() => updateStatus);
    openModal();
  };

  const updateStatus = async () => {
    try {
      const result = await axios.post(
        `${serverUrl}/api/admin/cv/updateStatus`,
        { data }
      );
      // console.log("response", result);
      if (result.status === 200) {
        setModalType({
          title: "Success",
          icon: "success",
          text: "Updated Successfully",
        });
        setShowCancelButton(false);
        setOnCancel(() => closeModal);
        setOnConfirm(() => closeModal);
        openModal();
        resetData();
      }
    } catch (err) {
      // console.log("error", err);
    }
  };

  return (
    <div>
      <div>
        <h1 style={{ textAlign: "center" }} className="title">Cv Status Change</h1>
        <div className="input-group">
          <input
            className="input-field"
            style={{ width: "110%" }}
            type="number"
            name="appno"
            value={data.appno}
            onChange={handleChange}
            placeholder="Enter Application Number"
          />
        </div>
        <div className="ProceedButton" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <button onClick={check}>Check</button>
        </div>
        {showStatus && (
          <div>
            <div className="checkDetails">
              <div>
                <h3>Status :</h3>
                {details.status === "V"
                  ? "Verified"
                  : details.status === "P"
                    ? "Pending"
                    : details.status === "W"
                      ? "Waiting List"
                      : details.status === "E"
                        ? "Not Eligible"
                        : "No status"}
              </div>
              <div>
                <h3>Staff Assigned :</h3> {details.verifier_name ? details.verifier_name : "Not Assigned"}
              </div>
            </div>

            <div style={{ marginTop: "20px", display: "flex", flexDirection: "column", alignItems: "center" }}>
              <label>
                <h3 style={{ textAlign: "center" }}>Change Status</h3>
              </label>
              <select name="status" onChange={handleChange} style={{ width: "200px", height: "30px", paddingLeft: "10px", borderRadius: "5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <option value="P" selected={data.status === "P"}>
                  Pending
                </option>
                <option value="V" selected={data.status === "V"}>
                  Verified
                </option>
              </select>
            </div>
            <div className="buttonContainer">
              <div className="ProceedButton" style={{ marginTop: "5 px" }}>
                <button onClick={updateStatusConfirmation}>Update</button>
              </div>
              <div className="ProceedButton">
                <button style={{ backgroundColor: "#6c757d", color: ' #ffffff' }}
                  className="log-btn button-secondary"
                  onClick={resetData}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <div
        style={{
          position: "relative",
          alignSelf: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <PopModal
          isOpen={isModalOpen}
          type={modalType}
          confirmButtonText="OK"
          showCancelButton={showCancelButton}
          cancelButtonText="Cancel"
          onConfirm={onConfirm}
          onCancel={onCancel}
        />
      </div>
    </div>
  );
};

export default ChangeStatus;
